import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CSSBuySpreadsheetArticle from "../pages/cssbuy-spreadsheet/page";
import FAQPage from "../pages/faq/page";
import SafetyPage from "../pages/safety/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import DisclaimerPage from "../pages/disclaimer/page";
import ContactPage from "../pages/contact/page";
import GuidesPage from "../pages/guides/page";
import ReviewsPage from "../pages/reviews/page";
import ShippingPage from "../pages/shipping/page";
import QCPage from "../pages/qc/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en",
    element: <Home />,
  },
  {
    path: "/pt-br",
    element: <Home />,
  },
  {
    path: "/de",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CSSBuySpreadsheetArticle />,
  },
  {
    path: "/guides",
    element: <GuidesPage />,
  },
  {
    path: "/reviews",
    element: <ReviewsPage />,
  },
  {
    path: "/shipping",
    element: <ShippingPage />,
  },
  {
    path: "/qc",
    element: <QCPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/safety",
    element: <SafetyPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/disclaimer",
    element: <DisclaimerPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;